/**
 * 开通会员引导组件
 * 组件内置开通文档高亮逻辑
 */
import ArkLoader from '@src/js/common/ark-extensions';
import componentConfig from './component-config';

export async function showRenameDialog(): Promise<void> {
    const renameExtension = await ArkLoader.extensionService.getExtension(componentConfig.name);
    renameExtension.show();
}
